/**
 * Parcelas de uma cobranca recorrente (mensalidade da Prop, spec 007 e 041): cada uma com o titulo ("Mensalidade 3",
 * "Avulsa 1"), o vencimento, o valor, o selo da situacao, um detalhe (observacao, motivo do cancelamento) e as acoes que
 * cabem nela. A prevista (calendario das proximas, 041 3.7) aparece mais apagada, com borda tracejada e sem acao.
 * Nao sabe a regra: quem diz a situacao, o rotulo e o que da pra fazer e o app, com o que o backend mandou.
 */
import type { ReactNode } from "react";
import { IconeCalendario } from "../icones";
import { Selo, type Tom } from "./Basicos";

export type ParcelaDaLista = {
  chave: string;
  titulo: ReactNode;
  /** Ja formatado ("30/10/2026"). */
  vencimento: ReactNode;
  /** Ja formatado ("R$ 297,00" ou "A definir"). */
  valor?: ReactNode;
  selo?: { tom: Tom; texto: string };
  /** Uma linha de apoio embaixo: observacao, motivo do cancelamento, de onde veio. */
  detalhe?: ReactNode;
  /** So leitura, do calendario previsto: mais apagada e sem acao. */
  prevista?: boolean;
  acoes?: ReactNode;
  /** Ocupa a largura toda embaixo (ex.: o comprovante que o cliente mandou pra esta parcela). */
  extra?: ReactNode;
};

/** `grade`: em colunas quando cabe (lista longa de itens curtos, como o calendario previsto). */
export function ListaDeParcelas({ itens, rotulo, vazio = "Nenhuma parcela por aqui.", grade }: { itens: ParcelaDaLista[]; rotulo: string; vazio?: string; grade?: boolean }) {
  if (!itens.length) return <p className="mtc-texto-2" style={{ margin: 0, fontSize: "var(--t-sm)" }}>{vazio}</p>;
  return (
    <ul className={`mtc-parcelas${grade ? " mtc-parcelas--grade" : ""}`} aria-label={rotulo}>
      {itens.map((p) => (
        <li key={p.chave} className="mtc-parcela" data-prevista={p.prevista || undefined}>
          <div className="mtc-parcela__linha">
            <div className="mtc-parcela__textos">
              <span className="mtc-parcela__titulo">{p.titulo}</span>
              <span className="mtc-parcela__meta">
                <span className="mtc-parcela__dado"><IconeCalendario tamanho={14} /><span className="mtc-oculto">Vencimento: </span><span className="mtc-mono">{p.vencimento}</span></span>
                {p.valor !== undefined && <span className="mtc-parcela__dado"><span className="mtc-oculto">Valor: </span><span className="mtc-mono">{p.valor}</span></span>}
              </span>
              {p.detalhe && <span className="mtc-parcela__detalhe">{p.detalhe}</span>}
            </div>
            {p.selo && <Selo tom={p.selo.tom}>{p.selo.texto}</Selo>}
          </div>
          {p.acoes && <div className="mtc-parcela__acoes">{p.acoes}</div>}
          {p.extra}
        </li>
      ))}
    </ul>
  );
}
